module.exports = __webpack_public_path__ + "static/media/clutch.b5e5654e.svg";